import React from 'react';

export const datepickerContextDefaultValues: {
  focusedDate: Date | null;
  isDateFocused: (date: Date) => boolean;
  isDateSelected: (date: Date) => boolean;
  isDateHovered: (date: Date) => boolean;
  isDateBlocked: (date: Date) => boolean;
  isFirstOrLastSelectedDate: (date: Date) => boolean;
  onDateFocus: (date: Date) => void;
  onDateHover: (date: Date | null) => void;
  onDateSelect: (date: Date) => void;
} = {
  focusedDate: null,
  isDateFocused: () => false,
  isDateSelected: () => true,
  isDateHovered: () => true,
  isDateBlocked: () => false,
  isFirstOrLastSelectedDate: () => true,
  onDateFocus: () => {},
  onDateHover: () => {},
  onDateSelect: () => {},
};

export default React.createContext(datepickerContextDefaultValues);
